<template>
	<div>
		<el-breadcrumb separator="/">
			<el-breadcrumb-item>计划管理</el-breadcrumb-item>
			<el-breadcrumb-item>跨厂调度</el-breadcrumb-item>
		</el-breadcrumb>
		<div class="form-bar">
			<el-form :inline="true">
				<el-form-item>
					<DateRange v-model="dateRange" />
				</el-form-item>
				<!-- <el-form-item >
					<el-select v-model="jt_id" placeholder="请选择车间" :clearable="true"  >
						<el-option-group  v-for="group in jtData" :key="group.value" :label="group.label">
							<el-option v-for="item in group.jtList" :key="item.value" :label="item.label" :value="item.value"  ></el-option>
						</el-option-group>
					</el-select>
				</el-form-item> -->
				<!-- <el-form-item >
					<el-input placeholder="请输入批次关键字" v-model="batchName" @keyup.enter.native="query" ></el-input>
				</el-form-item> -->
				<!-- <el-form-item >
						<el-select v-model="batchFilterStatus" placeholder="请选择筛选状态" :clearable="true"  >					
							<el-option v-for="item in filterStatus " :key="item.value" :label="item.label" :value="item.value"  ></el-option>
					
					</el-select>
				</el-form-item> -->
				<el-form-item>
					<el-button type="primary" v-on:click="query">可调出批次查询</el-button>
					<el-button type="primary" v-on:click="inputBatchHistory">调入历史记录</el-button>
					<el-button type="primary" v-on:click="outputBatchHistory">调出历史记录</el-button>
					<el-button type="primary" v-on:click="getInputBatch">可调入批次查询</el-button>
				</el-form-item>
			</el-form>
		</div>

		<div>
			<el-table border :data="tableData" v-loading="tableLoading" :default-sort="{ prop: 'roll_code', order: 'descending' }">
				<el-table-column type="index" width="60" label="序号"></el-table-column>
				<el-table-column prop="roll_code" label="批次名称" min-width="120"></el-table-column>
				<el-table-column prop="product_name" label="产品名称" width="120"></el-table-column>
				<!-- <el-table-column prop="jt_name" label="机台" width="100"></el-table-column> -->
				<el-table-column prop="jobOrderCode" label="工单号" width="120" :show-overflow-tooltip="true"></el-table-column>
				<el-table-column prop="to_factory" label="调出去向" width="150" v-if="outBatchList"> </el-table-column>
				<el-table-column prop="to_factory" label="调入去向" width="150" v-if="inBatchList"> </el-table-column>

				<!-- <el-table-column prop="to_factory" label="调入去向" width="150"  > </el-table-column> -->
				<el-table-column prop="uploadFinished" label="调出状态" width="150" v-if="outBathistory" :formatter="uploadStatus"> </el-table-column>
				<!-- <el-table-column prop="uploadFinished" label="调出状态" width="150" v-if="outBatchList"  :formatter="uploadStatus" > </el-table-column> -->
				<el-table-column prop="uploadFinished" label="调入状态" width="150" v-if="inBatchList" :formatter="uploadStatus"> </el-table-column>
				<!-- <el-table-column prop="uploadFinished" label="调出状态" width="150" v-if="outBathistory"  :formatter="uploadStatus" > </el-table-column> -->
				<el-table-column prop="scheduleOutProgress" label="调出进度" width="150" v-if="outBathistory" :formatter="processStatus"> </el-table-column>
				<!-- <el-table-column prop="scheduleOutProgress" label="调出进度" width="150" v-if="outBatchList" >  </el-table-column> -->
				<el-table-column prop="time" label="调出时间" width="200" v-if="outBatchList" :formatter="formatter">
					<!-- <template slot-scope="scope">
						<span v-text="formatDate(scope.row.time)"></span>
					</template> -->
				</el-table-column>
				<el-table-column prop="time" label="调入时间" width="200" v-if="inBatchList" :formatter="formatter">
					<!-- <template slot-scope="scope">
						<span v-text="formatDate(scope.row.time)"></span>
					</template> -->
				</el-table-column>
				<el-table-column prop="Insp_count" label="检测张数" width="80"></el-table-column>
				<el-table-column prop="bad_count" label="坏品张数" width="80"></el-table-column>
				<el-table-column prop="total_len" label="总长度" width="100"></el-table-column>
				<el-table-column prop="total_def_count" label="缺陷个数" width="120" sortable></el-table-column>
				<el-table-column prop="bad_len_printer" label="印刷缺陷长度" width="110"></el-table-column>
				<el-table-column prop="bad_len_qa" label="QA确认缺陷长度" width="140"></el-table-column>
				<el-table-column prop="bad_Len_qa_judgement" label="QA调整缺陷长度" width="140"></el-table-column>
				<el-table-column label="操作" width="100" fixed="right" v-if="action != ''">
					<template slot-scope="scope">
						<el-button :disabled="isTrue" v-if="action == 'output'" type="text" icon="el-icon-s-data" @click="showSelectFactory(scope.row)">调出</el-button>
						<el-button :disabled="isTrue" v-if="action == 'input'" type="text" icon="el-icon-s-data" @click="batchInput(scope.row)">调入</el-button>
					</template>
				</el-table-column>
			</el-table>
			<!-- <el-pagination
			layout="sizes, prev, pager, next, total"
			:page-count="pageCount"
			:page-sizes="[10, 50, 100, 200]"
			:size="pageSize"
			@current-change="currentChange"
			@size-change="sizeChange"
	       	></el-pagination> -->

			<!--分页-->
			<el-pagination layout="sizes, prev, pager, next, total" :page-count="pageCount" :page-sizes="[10, 50, 100, 150]" :size="pageSize" @current-change="currentChange" @size-change="sizeChange" :current-page.sync="currentPage"></el-pagination>
			<el-dialog title="选择调出/入工厂" :visible.sync="dialogVisible" width="30%">
				<el-select v-model="select_factory" placeholder="请选择工厂">
					<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
				</el-select>
				<span slot="footer" class="dialog-footer">
					<el-button @click="dialogVisible = false">取 消</el-button>
					<el-button type="primary" @click="batchOutput()">确 定</el-button>
				</span>
			</el-dialog>
		</div>
	</div>
</template>

<script>
	import DateRange from '@/components/DateRangePicker'
	import defectService from '@/service/defectService'
	import dictionaryData from '@/service/dictionaryData'
	import { $in, like } from '@/network/util/QueryBuilder'
	import { axios } from '@/network/util/request'
	import moment from 'moment'
	import factory from '@/network/requests/factory'
	export default {
		components: {
			DateRange,
			// Batches,
			// ImportList,
		},
		data() {
			return {
				dateRange: [],
				workshop: '',
				action: '',

				outBatchList: true,
				inBatchList: false,
				outBathistory: true,
				inBathistory: false,

				disbutton: true,
				tableData: [],
				jtData: [],
				jt_id: '',
				isTrue: false,
				tableLoading: false,
				pageSize: 10,
				pageIndex: 1,
				pageCount: 1,
				batchName: '',
				SearchNameSize: '',
				batchFilterStatus: 0,
				dialogVisible: false,
				filterStatus: [
					{
						value: 0,
						label: '未筛选',
					},
					{
						value: 1,
						label: '筛选完成',
					},
					{
						value: 2,
						label: '正在筛选',
					},
				],
				select_factory: '',
				options: [],
				select_Row: '',
				currentPage: 1,
			}
		},
		created() {
			this.useFactoryList()
			this.tableLoading = true
			this.jtData = dictionaryData.getJTListGroupByWorkshop()
			this.query()
		},
		watch: {
			SearchNameSize() {
				this.tableData = []
				;(this.pageIndex = 1), (this.pagesize = 10)
			},
		},
		methods: {
			processStatus(row, col) {
				if (row.scheduleOutProgress == 0) {
					return 0
				} else if (row.scheduleOutProgress > 1) {
					return '100%'
				}
				return row.scheduleOutProgress * 100 + '%'
			},
			uploadStatus(row, col) {
				if (row.uploadFinished == true) {
					return <div style="color:green"> 已完成 </div>
				} else {
					return <div style="color:red"> 未完成 </div>
				}
			},
			getStatus() {
				if (this.SearchNameSize == 'querySize') {
					//首页 调出
					this.outBatchList = true //调出
					this.inBatchList = false
					this.outBathistory = false
					this.inBathistory = false
				} else if (this.SearchNameSize == 'inputBatchHistorySize') {
					//调入批次历史
					this.outBatchList = false
					this.inBatchList = false
					this.outBathistory = false
					this.inBathistory = true //调入历史
				} else if (this.SearchNameSize == 'outputBatchHistorySize') {
					//调出批次历史
					this.outBatchList = false
					this.inBatchList = false
					this.outBathistory = true //调出历史
					this.inBathistory = false
				} else if (this.SearchNameSize == 'getInputBatchSize') {
					//调入
					this.outBatchList = false
					this.inBatchList = true //调入
					this.outBathistory = false
					this.inBathistory = false
				}
			},
			useFactoryList() {
				axios({ url: 'companyGroup/factory/list' })
					.then(res => {
						console.log('res', res)
						res.result.forEach((item, index) => {
							if (item.databaseName != localStorage.getItem('database')) {
								this.options.push({ value: item.databaseName, label: item.databaseName })
							}
						})
					})
					.catch(err => {
						this.$message({
							type: 'error',
							message: '请求错误' + err.message,
						})
					})
			},
			showSelectFactory(row) {
				if (typeof row.to_factory != 'undefined') {
					this.$message('不可调出')
					return
				}
				this.select_Row = row
				this.dialogVisible = true
			},
			/**
			 * 格式化日期。
			 */
			formatDate(date) {
				if (date) return moment(date.$date).format('YYYY-MM-DD HH:mm:ss')
			},
			formatter(row, column) {
				if (row.time) {
					return moment(row.time.$date).format('YYYY-MM-DD HH:mm:ss')
				}
			},
			batchQuery() {
				this.action = 'batches.query'
			},
			importQuery() {
				this.action = 'import.query'
			},
			getFilter() {
				var filter = {}
				var count = 0
				console.log('wejiansdsd', this.dateRange)
				if (this.dateRange !== null && this.dateRange.length > 1) {
					filter['begin_time'] = {
						$gte: { $date: new Date(this.dateRange[0]).getTime() },
						$lte: { $date: new Date(this.dateRange[1]).getTime() },
					}

					count++
				}

				if (this.jt_id) {
					filter['jt_id'] = this.jt_id
					count++
				}

				if (this.batchName) {
					filter['roll_code'] = like(this.batchName)
					count++
				}

				if (this.batchFilterStatus >= 0 && this.batchFilterStatus <= 2) {
					filter['filter_status'] = this.batchFilterStatus
					count++
				}
				console.log('未满', filter)

				if (count == 0) filter = undefined

				return filter
			},
			/**
			 * 查询所有批次。
			 */
			query() {
				this.getChangeIndex('querySize')
				this.SearchNameSize = 'querySize'
				this.getStatus()
				this.tableData = []
				this.action = 'output'
				this.isTrue = false
				this.tableLoading = true
				var filter = this.getFilter()
				defectService.getDefectStatList(this.pageIndex, this.pageSize, filter).then(res => {
					var defectArray = res.data
					// console.log("djisd0",res.totalPage)
					axios({ url: `/schedule/out/history`, method: 'get' }).then(res => {
						var historyArray = res._embedded
						defectArray.forEach(async (v, i) => {
							v.to_factory = historyArray.find(t => t.origin_id == v._id.$oid)?.to_factory
							v.time = historyArray.find(t => t.origin_id == v._id.$oid)?.time
						})
						this.tableData = defectArray
					})
					this.pageCount = res.totalPage
					console.log('sdddddd', res)
					this.tableLoading = false
				})
			},

			/**
			 * 获取可调入批次。
			 */
			getInputBatch() {
				this.getChangeIndex('getInputBatchSize')
				this.SearchNameSize = 'getInputBatchSize'
				this.getStatus()
				this.tableLoading = true
				this.action = 'input'
				this.isTrue = false
				// this.pageIndex = 1
				// this.pageSize = 10

				var search_filter = {}

				if (this.dateRange !== null && this.dateRange.length > 1) {
					search_filter['time'] = {
						$gte: { $date: new Date(this.dateRange[0]).getTime() },
						$lte: { $date: new Date(this.dateRange[1]).getTime() },
					}
				}
				search_filter['filter_status'] = 0

				axios({ url: `/schedule/remote`, method: 'get', params: { filter: search_filter, page: this.pageIndex, pagesize: this.pageSize } }).then(res => {
					var filter = {}
					var id_array = ([] || res._embedded).map(t => ({
						$oid: t.origin_id,
					}))
					filter['_id'] = { $in: id_array }
					// this.tableData = res._embedded
					//
					var historyArray = res._embedded
					if (!historyArray) historyArray = []

					defectService.getDefectStatList(this.pageIndex, this.pageSize, filter).then(res => {
						var defectArray = res.data

						this.tableLoading = false

						historyArray.forEach(async (v, i) => {
							v.product_name = defectArray.find(t => t._id?.$oid == v.origin_id)?.product_name
							v.jt_name = defectArray.find(t => t._id?.$oid == v.origin_id)?.jt_name
							v.jobOrderCode = defectArray.find(t => t._id?.$oid == v.origin_id)?.jobOrderCode
							// console.log(v)
						})

						// console.log(historyArray)
						this.tableData = historyArray

						// this.tableData = []
					})
					this.pageCount = res._total_pages

					// product_name jt_name jobOrderCode
				})
			},
			/**
			 * 查询调入历史。
			 */
			inputBatchHistory() {
				this.getChangeIndex('inputBatchHistorySize')
				this.SearchNameSize = 'inputBatchHistorySize'
				this.getStatus()
				this.action = 'input'
				;(this.isTrue = true), (this.tableLoading = true)
				// this.pageIndex = 1
				// this.pageSize = 10
				var search_filter = {}
				if (this.dateRange !== null && this.dateRange.length > 1) {
					search_filter['time'] = {
						$gte: { $date: new Date(this.dateRange[0]).getTime() },
						$lte: { $date: new Date(this.dateRange[1]).getTime() },
					}
				}
				search_filter['filter_status'] = 0
				axios({ url: `/schedule/in/history`, method: 'get', params: { filter: search_filter, page: this.pageIndex, pagesize: this.pageSize } }).then(res => {
					var filter = {}
					var id_array = ([] || res._embedded).map(t => ({
						$oid: t.origin_id,
					}))
					filter['_id'] = { $in: id_array }
					// this.tableData = res._embedded
					//
					var historyArray = res._embedded

					defectService.getDefectStatList(undefined, undefined, filter).then(res => {
						var defectArray = res.data

						this.tableLoading = false

						historyArray.forEach(async (v, i) => {
							v.product_name = defectArray.find(t => t._id?.$oid == v.origin_id)?.product_name
							v.jt_name = defectArray.find(t => t._id?.$oid == v.origin_id)?.jt_name
							v.jobOrderCode = defectArray.find(t => t._id?.$oid == v.origin_id)?.jobOrderCode
							// console.log(v)
						})

						// console.log(historyArray)
						this.tableData = historyArray
						// this.tableData = []
					})
					this.pageCount = res._total_pages
				})
			},

			getChangeIndex(index) {
				if (this.SearchNameSize !== index) {
					this.currentPage = 1
					this.pageSize = 10
					this.pageIndex = 1
				}
			},
			/**
			 * 查询调出历史。
			 *
			 */
			outputBatchHistory() {
				this.getChangeIndex('outputBatchHistorySize')
				console.log('paenindex', this.pageIndex)
				this.SearchNameSize = 'outputBatchHistorySize'
				this.getStatus()
				this.action = 'output'
				this.isTrue = true
				this.tableLoading = true
				var search_filter = {}
				if (this.dateRange !== null && this.dateRange.length > 1) {
					search_filter['time'] = {
						$gte: { $date: new Date(this.dateRange[0]).getTime() },
						$lte: { $date: new Date(this.dateRange[1]).getTime() },
					}
				}
				search_filter['filter_status'] = 0
				axios({ url: `/schedule/out/history`, method: 'get', params: { filter: search_filter, page: this.pageIndex, pagesize: this.pageSize } }).then(res => {
					var filter = {}
					var id_array = ([] || res._embedded).map(t => ({
						$oid: t.origin_id,
					}))
					filter['_id'] = { $in: id_array }
					// this.tableData = res._embedded
					//
					var historyArray = res._embedded

					defectService.getDefectStatList(undefined, undefined, filter).then(res => {
						var defectArray = res.data

						this.tableLoading = false

						historyArray.forEach(async (v, i) => {
							v.product_name = defectArray.find(t => t._id?.$oid == v.origin_id)?.product_name
							v.jt_name = defectArray.find(t => t._id?.$oid == v.origin_id)?.jt_name
							v.jobOrderCode = defectArray.find(t => t._id?.$oid == v.origin_id)?.jobOrderCode
							// console.log(v)
						})

						// console.log(historyArray)
						this.tableData = historyArray
						// this.tableData = []
					})
					// this.pageCount = res._total_pages
					this.pageCount = res._total_pages

					// product_name jt_name jobOrderCode
				})
			},
			/**
			 * 调出。
			 */
			batchOutput() {
				var data = {
					defectStatisId: this.select_Row._id.$oid,
					toFactory: this.select_factory,
				}
				axios({ url: `/schedule/out`, method: 'POST', data }).then(res => {
					res = res.data

					this.$message('调出成功')
					this.dialogVisible = false

					//重新加载列表。
					this.query()
				})
			},
			/**
			 * 调入。
			 */
			batchInput(row) {
				var data = {
					defectStatisId: row.origin_id,
					toFactory: localStorage.getItem('database'),
				}

				axios({ url: `/schedule/in`, method: 'POST', data }).then(res => {
					res = res.data
					this.$message('调入成功')
				})
			},

			/**
			 * 判断page属于那个按钮，
			 */
			SearchfileSize() {
				if (this.SearchNameSize == 'querySize') {
					this.query()
				} else if (this.SearchNameSize == 'inputBatchHistorySize') {
					this.inputBatchHistory()
				} else if (this.SearchNameSize == 'outputBatchHistorySize') {
					this.outputBatchHistory()
				} else if (this.SearchNameSize == 'getInputBatchSize') {
					this.getInputBatch()
				}
			},

			/**
			 *  分页
			 */
			currentChange(index) {
				this.tableLoading = true
				this.pageIndex = index
				this.SearchfileSize()
			},
			/**
			 * 每页数量
			 */
			sizeChange(size) {
				this.tableLoading = true
				this.pageIndex = 1
				this.pageSize = size
				this.SearchfileSize()
			},
			/**
			 * 缺陷浏览。
			 */
			handleBrowser(row) {
				const routeData = this.$router.resolve({ name: 'Browser', query: { batch_id: row._id.$oid } })
				window.open(routeData.href, '_blank')
			},
			/**
			 * 查看报表。
			 */
			handleViewReport(row) {
				this.$router.push({ name: 'DefectReport' })
			},
		},
	}
</script>

<style></style>
